import { InternalTransferMethodEnum } from '@interfaces';
import { CostBasisMethodHolding } from '@interfaces/cost-basis/cost-basis.service.interface';
import { InvestmentObjectivesGetData, ISelectedAccount, Position } from '@interfaces/models';
import { SettlementFundAoAEnum } from '@interfaces/settlement-fund/settlement-fund.enum';
import {
  MultiITFrom,
  MultiITMXM,
  MultiITTo,
  MultiITToAccount,
  MultiITTriage,
} from '@interfaces/state';
import { createAction, props } from '@ngrx/store';

export const UpdateMultiITTriage = createAction(
  '[Multi-IT] Update Triage',
  props<{ payload: Partial<MultiITTriage> }>(),
);

export const UpdateMultiITFrom = createAction(
  '[Multi-IT] Update Transfer From',
  props<{ payload: Partial<MultiITFrom> }>(),
);

export const SetMultiITFromAccount = createAction(
  '[Multi-IT] Set From Account',
  props<{ payload: ISelectedAccount | null }>(),
);

export const SetMultiITTransferMethod = createAction(
  '[Multi-IT] Set Transfer Method',
  props<{ payload: InternalTransferMethodEnum }>(),
);

export const AddMultiITToAccount = createAction(
  '[Multi-IT] Add To Account',
  props<{ payload: MultiITToAccount }>(),
);

export const UpdateMultiITToAccount = createAction(
  '[Multi-IT] Update To Account',
  props<{ id: string; payload: Partial<MultiITToAccount> }>(),
);

export const RemoveMultiITToAccount = createAction(
  '[Multi-IT] Remove To Account',
  props<{ payload: string }>(),
);

export const SetMultiITToAccount = createAction(
  '[Multi-IT] Set To Account',
  props<{ payload: MultiITTo }>(),
);

export const ClearMultiITToAccounts = createAction('[Multi-IT] Clear All To Accounts');

export const SetMultiITSelectedHoldings = createAction(
  '[Multi-IT] Set Selected Holdings',
  props<{ payload: Position[] }>(),
);

export const SetMultiITMXM = createAction(
  '[Multi-IT] Set MXM Data',
  props<{ payload: MultiITMXM }>(),
);

export const ClearMultiITState = createAction('[Multi-IT] Clear State');

export const MultiITSummaryContinue = createAction('[Multi-IT] Summary Continue');

export const SyncMultiITToInternalTransfer = createAction('[Multi-IT] Sync To Classic IT');

export const ClearMultiITToPositions = createAction('[Multi-IT] Clear To Positions');

export const ApplyMultiITCostBasisShownMethod = createAction(
  '[Multi-IT] Apply Cost Basis Shown Method',
);

export const LoadMultiITCostBasisMethodSuccess = createAction(
  '[Multi-IT] Cost Basis Method Success',
  props<{ payload: CostBasisMethodHolding[] }>(),
);

// OA Collection Management
export const StartNewAccountCollection = createAction(
  '[Multi-IT] Start New Account Collection',
  props<{ transactionId: string }>(),
);

export const CompleteNewAccountCollection = createAction(
  '[Multi-IT] Complete New Account Collection',
  props<{ transactionId: string }>(),
);

export const UpdateCurrentlyCollecting = createAction(
  '[Multi-IT] Update Which Account Info We Are Collecting',
);

export const ClearOACollectionState = createAction('[Multi-IT] Clear OA Collection State');

// Per-Account OA Data Updates (objectives and settlementFund are per-account)
export const UpdateITMToAccountObjectives = createAction(
  '[Multi-IT OA] Update To Account Objectives',
  props<{ id: string; objectives: InvestmentObjectivesGetData }>(),
);

export const UpdateITMToAccountSettlementFund = createAction(
  '[Multi-IT OA] Update To Account Settlement Fund',
  props<{ id: string; settlementFund: SettlementFundAoAEnum }>(),
);

export const MultiITSubmit = createAction('[Multi-IT] Submit');

// Payload-less: fireCashSweepTags$ derives the tags from selectMultiITCashSweepSegments.
export const TrackMultiITCashSweepTransfer = createAction('[Multi-IT] Track Cash Sweep Transfer');
